<template>
    <div class="headTitle">
        <div class="title">
            {{ title }}
        </div>
    </div>
</template>
  
<script>
export default {
    props: {
        title: {
            type: String,
            default: '定义化标题'
        },
    }
}
</script>
  
<style scoped>
.headTitle {
    width: 100%;
    height: 40px;
    display: flex;
    margin: 0px 0px 12px 0px;
}

.title {
    width: 100%;
    height: 100%;
    font-size: 16px;
    font-weight: 400;
    color: #61a3f1;
    line-height: 40px;
    padding-left: 24px;
    position: relative;
}

.title::before {
    content: "";
    width: 7px;
    height: 7px;
    background: #01c8ff;
    left: 10px;
    position: absolute;
    top: 17px;
}
</style>